/* Chat panel markup -- shared static template used by both v1 (main.js)
   and the v2 shell (shell-v2.js). Pure HTML string; no interpolation. */

export function chatPanelMarkup() {
  return `
    <div class="chat-panel">
      <div class="chat-panel-header">
        <span class="chat-panel-icon"><i class="ic ic-zap"></i></span>
        <span class="chat-panel-title">SAP CPQ Assistant</span>
        <div class="chat-panel-actions">
          <button class="backend-picker" id="btnBackendPicker" title="Switch coding-agent backend">
            <span class="backend-picker-label" id="backendPickerLabel">…</span>
            <i class="ic ic-sm ic-chevron-down"></i>
          </button>
          <button class="btn-icon" id="btnChatHistory" title="Conversation History" aria-label="Conversation history">
            <i class="ic ic-history"></i>
          </button>
          <button class="btn-icon" id="btnNewConversation" title="New Chat" aria-label="New chat">
            <i class="ic ic-plus"></i>
          </button>
          <button class="btn-icon" id="btnCollapseRight" title="Collapse Chat" aria-label="Collapse chat">
            <i class="ic ic-chevron-right"></i>
          </button>
        </div>
        <div class="backend-menu" id="backendMenu" hidden></div>
        <div class="history-dropdown" id="historyDropdown" hidden></div>
      </div>
      <div class="chat-stream" id="chatStream">
        <div class="chat-welcome" id="chatWelcome">
          <div class="welcome-icon">
            <i class="ic ic-file-text welcome-glyph"></i>
          </div>
          <h2>What can I help you with?</h2>
          <p>Create scripts, manage configurations, sync with SAP CPQ cloud.</p>
          <div class="welcome-chips">
            <button class="chip" data-prompt="Create a script that sets custom field 'Quantity' to 4">Create a script</button>
            <button class="chip" data-prompt="Find quote 5901">Find a quote</button>
            <button class="chip" data-prompt="List all global scripts">List scripts</button>
            <button class="chip" data-prompt="Show sync status">Sync status</button>
          </div>
        </div>
      </div>
      <div class="agent-dock idle" id="agentDock" hidden></div>
      <footer class="composer">
        <div class="at-autocomplete" id="atAutocomplete" role="listbox" aria-label="Suggestions" hidden></div>
        <div class="composer-attachments" id="composerAttachments" hidden></div>
        <div class="composer-inner">
          <button class="btn-attach" id="btnAttach" title="Attach image, markdown, or DOCX (or paste an image)" aria-label="Attach a file">
            <i class="ic ic-paperclip" style="font-size:16px"></i>
          </button>
          <input type="file" id="fileAttachInput" accept=".docx,image/png,image/jpeg,image/jpg,.md,.markdown" multiple hidden />
          <textarea id="promptInput" rows="1" aria-label="Message AgentCPQ" placeholder="Ask AgentCPQ anything, paste/attach images, @ for files, / for commands"></textarea>
          <button class="btn-send" id="btnSend" title="Send" aria-label="Send message" disabled>
            <i class="ic ic-send" style="font-size:18px"></i>
          </button>
        </div>
        <div class="composer-footer-row">
          <button class="autonomy-chip tone-neutral" id="autonomyChip" type="button" title="Checking agent autonomy…" aria-label="Agent autonomy">
            <span class="autonomy-dot dot-neutral"></span><span class="autonomy-label">Autonomy…</span>
          </button>
          <div class="composer-hint">Enter to send, Shift+Enter for newline</div>
        </div>
      </footer>
    </div>
  `;
}
